export const authSettings = {
    authority: 'https://auth.paperback.moe',
    clientId: '11b4c97b-c1de-4f5f-8a48-040c48de0ad4',
    redirectUri: `${window.location.origin}/auth-callback`,
    popupRedirectUri: `${window.location.origin}/auth-popup-callback`,
    automaticSilentRenew: true,
    automaticSilentSignin: false,
    silentRedirectUri: `${window.location.origin}/silent-renew.html`,
    responseType: 'code',
    scope: 'openid profile email offline_access api',
    postLogoutRedirectUri: `${window.location.origin}`,
    response_mode: 'query',
    tokenEndpoint: 'https://auth.paperback.moe/oauth2/token',
}

export const signUpLinkPopup = `${authSettings.authority}/oauth2/register?client_id=${authSettings.clientId}&response_type=${authSettings.responseType}&redirect_uri=${authSettings.popupRedirectUri}`

export const signUpLink = `${authSettings.authority}/oauth2/register?client_id=${authSettings.clientId}&response_type=${authSettings.responseType}&redirect_uri=${authSettings.redirectUri}`
